export default {
  DATAFLIK_PROMO_DEMO: "https://dataflik.com/schedule-a-demo",
  TERMS_AND_CONDITIONS: "https://www.termsfeed.com/live/66221b38-68be-4791-b6c5-635baad2311e",
  WEBSITE: "https://www.dataflik.com",
  DEMO_CALENDAR: `https://calendly.com/d/cv2d-tzj-55v/dataflik-demo-in-app?hide_event_type_details=1&hide_gdpr_banner=1&utm_source=dataflik&utm_medium=in-app-cta&utm_campaign=in-app-demo`,
};
